export const IMAGE_TYPE_REG_EXP = /image\//;
export const VIDEO_TYPE_REG_EXP = /video\//;
